// extracted by mini-css-extract-plugin
export default {"reloadButton":"FlYZPR","content":"sE7BMi","textContainer":"MSYvkv","textTitle":"PW8pwR","text":"_wADPD"};